
import { Button, IconButton } from '@mui/material';
import './blossom.css';
import blossom1 from "../../../../../assets/blossom/blossom1.jpeg";
import blossom2 from "../../../../../assets/blossom/blossom2 (2).jpeg";
import blossom3 from "../../../../../assets/blossom/blossom3.jpeg";
import blossom4 from "../../../../../assets/blossom/blossom4.jpeg";
import blossom5 from "../../../../../assets/blossom/blossom5.jpeg";
import blossom6 from "../../../../../assets/blossom/blossom6.jpeg";
import blossom7 from "../../../../../assets/blossom/blossom7.jpeg";
import blossom8 from "../../../../../assets/blossom/blossom8.jpeg";
import blossom9 from "../../../../../assets/blossom/blossom9.jpeg";
import blossom10 from "../../../../../assets/blossom/blossom10.jpeg";
import blossom11 from "../../../../../assets/blossom/blossom11.jpeg";
import blossom12 from "../../../../../assets/blossom/blossom12.jpeg";
import blossom13 from "../../../../../assets/blossom/blossom13.jpeg";
import blossom14 from "../../../../../assets/blossom/blossom14.jpeg";
import BackIcon from '../../../../../components/back/back';

const FicusFamilies = [
    { id: 1, name: "Magnolia Grandiflora", img: blossom1, url: "/flowers" },
    { id: 2, name: "Photenia", img: blossom2, url: "/fruits" },
    { id: 3, name: "Jacaranda", img: blossom3, url: "/quercus" },
    { id: 4, name: "Delonix", img: blossom4, url: "/palms" },
    { id: 5, name: "Albizia", img: blossom5, url: "/ficus" },
    { id: 6, name: "Magnolia souligiana", img: blossom6, url: "/ficus" },
    { id: 7, name: "Cassia nodosa", img: blossom7, url: "/ficus" },
    { id: 8, name: "Loropetalum", img: blossom8, url: "/ficus" },
    { id: 9, name: "Bauhinia", img: blossom9, url: "/ficus" },
    { id: 10, name: "Plumeria", img: blossom10, url: "/ficus" },
    { id: 11, name: "Callistemon", img: blossom11, url: "/ficus" },
    { id: 12, name: "Lagerstroemia", img: blossom12, url: "/ficus" },
    { id: 13, name: "Chorisia", img: blossom13, url: "/ficus" },
    { id: 14, name: "Tabrbuia", img: blossom14, url: "/ficus" },

];



export default function BlossomCategorieDesktop() {
    return (
        <div className="ficus-container">
            <BackIcon />
            <div className="title-overlay">
                <div className="title-with-flowers">
                    <span className="flower-icon">🌸</span>
                    <h1>Blossom Collection</h1>
                    <span className="flower-icon">🌸</span>
                </div>
            </div>

            <div className="plants-category-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" style={{ marginTop: "2rem" }}>
                {FicusFamilies.map((ficus) => (
                    <div key={ficus.id} className=" ficus-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105">
                        <img
                            src={ficus.img}
                            alt={ficus.name}
                            className="w-full h-60 object-cover rounded-lg mb-4"
                        />
                        <p className="plant-name">{ficus.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
